import { useState } from 'react';
import { LANGUAGES } from '../constants/globalConstants';

export const useLanguage = <T>(translationsByLang: { [key: string]: T }) => {
  const [language, setLanguage] = useState<string>(
    localStorage.getItem('selectedLanguage') || LANGUAGES.Serbian,
  );

  const changeLanguage = (lang: string) => {
    setLanguage(lang);
    localStorage.setItem('selectedLanguage', lang);
  };

  const translations =
    translationsByLang[language] || translationsByLang[LANGUAGES.Serbian];

  return { language, changeLanguage, translations };
};
